/**
 * Auth Resolver für POS Terminal
 *
 * Wartet auf vollständige Auth-Initialisierung bevor Routes aktiviert werden.
 * Verhindert Race Conditions wo Guards laufen bevor User-Claims geladen sind.
 *
 * @author TypeScript Developer
 * @version 1.0.0
 */

import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { filter, take, timeout, catchError } from 'rxjs/operators';
import { of } from 'rxjs';

/**
 * Resolver für Auth Initialization
 *
 * Wartet bis authInitialized$ true ist (max 5s).
 * Bei Timeout wird trotzdem fortgefahren (Fallback für Edge Cases).
 */
export const authResolver: ResolveFn<boolean> = (route, state) => {
  const authService = inject(AuthService);

  console.log('[Terminal AuthResolver] Waiting for auth initialization...');

  return authService.authInitialized$.pipe(
    filter(initialized => initialized === true),
    take(1),
    timeout(5000),
    catchError(err => {
      console.warn('[Terminal AuthResolver] Timeout - proceeding anyway');
      return of(true);
    })
  );
};
